<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="d-flex justify-content-center align-items-center">
          <div class="jumbotron jumbotron mt-5">
            <div class="m-5">
              <h2>ثبت اطلاعات با موفقیت انجام شد</h2>
              <br />
              <h1>باتشکر از همکاری صمیمانه شما</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'done',
  mounted () {
    this.$root.member = null
  }
}
</script>

<style scoped>
html, body {
  height: 100%;
}

div {
  height: inherit;
}
.jumborton {
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Done.vue